import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How does the AI learning assistant work?",
    answer:
      "Our AI assistant provides personalized recommendations, learning guidance, and instant feedback based on user progress.",
  },
  {
    question: "Can the platform be customized?",
    answer:
      "Yes. Learning paths, branding, users, and assessments can all be customized for your organization.",
  },
  {
    question: "Does it support certification?",
    answer:
      "Yes. Certificates are generated automatically after learners complete the required courses and assessments.",
  },
  {
    question: "Can I monitor employee progress?",
    answer:
      "Absolutely. Administrators have access to real-time dashboards, analytics, and detailed reports.",
  },
];

export default function FAQ() {
  const [active, setActive] = useState(0);

  return (
    <section
      id="faq"
      className="bg-slate-950 py-28"
    >
      <div className="container mx-auto px-6 max-w-4xl">

        <div className="text-center mb-16">

          <p className="text-cyan-400 font-semibold">
            Frequently Asked Questions
          </p>

          <h2 className="text-5xl font-bold text-white mt-4">
            Everything You Need to Know
          </h2>

        </div>

        <div className="space-y-5">

          {faqs.map((faq, index) => {

            const opened = active === index;

            return (

              <div
                key={index}
                className="rounded-2xl border border-white/10 bg-slate-900 overflow-hidden"
              >

                <button
                  onClick={() => setActive(opened ? -1 : index)}
                  className="w-full flex justify-between items-center p-6"
                >

                  <span className="text-lg font-semibold text-white">
                    {faq.question}
                  </span>

                  <motion.div
                    animate={{
                      rotate: opened ? 180 : 0,
                    }}
                  >

                    <ChevronDown />

                  </motion.div>

                </button>

                <AnimatePresence>

                  {opened && (

                    <motion.div
                      initial={{ height: 0 }}
                      animate={{ height: "auto" }}
                      exit={{ height: 0 }}
                    >

                      <p className="px-6 pb-6 text-slate-400 leading-8">

                        {faq.answer}

                      </p>

                    </motion.div>

                  )}

                </AnimatePresence>

              </div>

            );
          })}

        </div>

      </div>

    </section>
  );
}